import React from 'react';

const ListOptions = ({ editor }) => {
  return (
    <div className="listOptions">
      <h3>List</h3>
      {/* Options will be added later */}
    </div>
  );
};

export default ListOptions;
